export const SLICE_BASE_NAME = 'auth'
export const RndTeam = ['dimitriy@spotower.com','aitan@spotower.com','ella@spotower.com', 'talkedem@spotower.com', 'shahaf@spotower.com', 'danielresnikow@spotower.com', 'shachar@spotower.com']